exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--option__j-f5J{display:-webkit-box;display:-ms-flexbox;display:flex;margin-top:5px}.styles--checkbox__34d-1{margin-right:10px}\n", ""]);

// exports
exports.locals = {
	"option": "styles--option__j-f5J",
	"checkbox": "styles--checkbox__34d-1"
};